import React, { FC } from 'react'

import { InventorySliderImage } from './index.style'

interface IInventorySliderImagePreviewProperties {
    image: string
    onClick: () => void
}

export const InventorySliderImagePreview: FC<IInventorySliderImagePreviewProperties> = properties => {
    return (
        <InventorySliderImage onClick={properties.onClick}>
            <object data={properties.image} type="image/png" width={75} height={75}>
                <img src="https://www.obispadesign.com.br/storage/default.png" width={75} height={75} />
            </object>
        </InventorySliderImage>
    )
}
